export default{
  //返回顶部
  backTap(){
    window.scrollTo(0, 0);
  },
  // 倒计时
  countTime(timeStamp) {
    var day;
    var hour;
    var min;
    var seconds;

    day = parseInt(timeStamp / (24 * 60 * 60)) // 计算整数天数
    var afterDay = timeStamp - day * 24 * 60 * 60 // 取得算出天数后剩余的秒数
    hour = parseInt(afterDay / (60 * 60)) // 计算整数小时数
    var afterHour = timeStamp - day * 24 * 60 * 60 - hour * 60 * 60 // 取得算出小时数后剩余的秒数
    min = parseInt(afterHour / 60) // 计算整数分
    seconds = parseInt(timeStamp - day * 24 * 60 * 60 - hour * 60 * 60 - min * 60) // 取得算出分后剩余的秒数

    if (day < 10) {
      day = '0' + day;
    }

    if (hour < 10) {
      hour = '0' + hour
    };

    if (min < 10) {
      min = '0' + min;
    }

    if (seconds < 10) {
      seconds = '0' + seconds;
    }

    const restStamp = {
      day: day,
      hour: hour,
      min: min,
      seconds: seconds
    }
    return restStamp
  },
  // 获得距离活动开始还剩余的时间
  mistiming(s, e, obj) {
    var nowtime = Date.parse(new Date()) / 1000;
    var time = '';
    var str='';var strs ='';
    var lang=$cookies.get('lang')
    if (nowtime > s) {
      time = nowtime;
      var timeStamp = e - time;
      obj.times = this.countTime(timeStamp);
      if(lang=='en'){
        str = `${obj.times.day}day${obj.times.hour}hour${obj.times.min}minute${obj.times.seconds}second`;
      }else{
        str = `${obj.times.day}天${obj.times.hour}时${obj.times.min}分${obj.times.seconds}秒`;
      }
      obj.countTxt = str;
      var TimeDown = setInterval(() => {
        if (timeStamp > 0) {
          timeStamp--;
          const newTime = this.countTime(timeStamp);
          if(lang=='en'){
            str = `${newTime.day}day${newTime.hour}hour${newTime.min}minute${newTime.seconds}second`;
            obj.countDown="Distance to the end of the activity";
          }else{
            str = `${newTime.day}天${newTime.hour}时${newTime.min}分${newTime.seconds}秒`;
            obj.countDown="距离活动结束";
          }
          obj.countTxt = str;
        } else {
          obj.countDown="";
          if(lang=='en'){
            obj.countTxt="Activity ended";
          }else{
            obj.countTxt="活动已结束";
          }
          clearInterval(TimeDown);
        }
      }, 1000)
    } else {
      let endtime =s - nowtime;
      obj.times = this.countTime(endtime);
      
      if(lang=='en'){
        strs = `${obj.times.day}day${obj.times.hour}hour${obj.times.min}minute${obj.times.seconds}second`
      }else{
        strs = `${obj.times.day}天${obj.times.hour}时${obj.times.min}分${obj.times.seconds}秒`
      }
      obj.countTxt = strs;
      var TimeOut = setInterval(() => {
        if (endtime > 0) {
          endtime--;
          const newTime = this.countTime(endtime);
          if(lang=='en'){
            str = `${newTime.day}day${newTime.hour}hour${newTime.min}minute${newTime.seconds}second`;
            obj.countDown="Distance from the start of the activity";
          }else{
            str = `${newTime.day}天${newTime.hour}时${newTime.min}分${newTime.seconds}秒`
            obj.countDown="距离活动开始";
          }
          obj.countTxt = str;
        } else {
          // obj.countTxt = '活动已结束'
          clearInterval(TimeOut);
        }
      }, 1000)
    }

  },
  //判断是否为空
  isnull(val) {
    if (val == "" || val == null || val == undefined)
      return true;
    return false;
  },
  /* 是否手机号码*/
  isMobile(value) {
    var txt='';
    const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
    var lang=$cookies.get('lang')
    if (value == '' || value == undefined || value == null) {
      if(lang=='en'){
        txt='Please enter your mobile phone number'
      }else{
        txt='请输入手机号';
      }
      return txt;
    } else {
      if ((!reg.test(value)) && value != '') {
        if(lang=='en'){
          txt='Incorrect mobile phone number format'
        }else{
          txt='手机号码格式不正确';
        }
        return txt;
      }else {
        txt='';
        return txt;
      }
    }
  },
  //倒计时
  countDown(obj,num) {
      console.log(num)
    var lang=$cookies.get('lang')
    if(num==1){
      var Timer = setInterval(() => {
        if (obj.code_time > 0) {
          obj.code_time--;
          if(lang=='en'){
            obj.code_text = `${obj.code_time}Get in seconds`;
          }else{
            obj.code_text = `${obj.code_time}秒后获取`;
          }
          obj.code_flag = false;
        } else {
          obj.code_flag = true;
          obj.code_time = 60;
          if(lang=='en'){
            obj.code_text = `Reacquire`;
          }else{
            obj.code_text = `重新获取`;
          }

          clearInterval(Timer);
        }
      }, 1000)
    }else{
      var Timer = setInterval(() => {
        if (obj.re_code_time > 0) {
          obj.re_code_time--;
          if(lang=='en'){
            obj.re_code_text = `${obj.re_code_time}Get in seconds`;
          }else{
            obj.re_code_text = `${obj.re_code_time}秒后获取`;
          }
          obj.re_code_flag = false;
        } else {
          obj.re_code_flag = true;
          obj.re_code_time = 60;
          if(lang=='en'){
            obj.re_code_text = `Reacquire`;
          }else{
            obj.re_code_text = `重新获取`;
          }
          clearInterval(Timer);
        }
      }, 1000)
    }

  },
  //默认图设置
  pic(obj) {
    obj.defaultPic = 'this.src="' + require('@/assets/img/default.png') + '"'; //默认图
  },
  //判断是否登录
  publiLogin(that){
    if(this.isnull(that.$cookies.get("userInfo"))){
      return false;
    } else {
      return true;
    }
  },
    //获取链接上参数
    getParam(variable) {
      var query = window.location.search.substring(1);
      var query3 = window.location.href.split("?");
      query = query + '&' + query3[2];
      console.log("param：" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
  
}





// WEBPACK FOOTER //
// ./src/utils/public.js